import React from "react"
import { ITextProps } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {}

const Body3 = (props: Props) => {
  const className = `font-raleway-light text-xs ${mapStylesFromProps(props)}`
  return <span className={className}>{props.children}</span>
}

export default Body3
